exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".case-title{margin-top:47px;margin-bottom:10px}.heading-h1{margin-top:40px}", ""]);

// exports
